import React, { useContext, useEffect, useState } from "react";
import useArrayState from "@clave/use-array-state";
const BidAllContext = React.createContext(null);
const BidAllContextProvider = (props) => {
    const [bidsActions, setBidsActions] = useArrayState([]);
    const [available, setAvailable] = useState(false);
    function subscribe(lotId, onBid) {
        if (bidsActions.find(i => i.lotId === lotId))
            return;
        setBidsActions.append({ lotId, onBid });
    }
    function unsubscribe(lotId) {
        setBidsActions.removeWhere(i => i.lotId === lotId);
    }
    async function bidAll() {
        await Promise.all(bidsActions.map(i => i.onBid()));
    }
    useEffect(() => {
        setAvailable(bidsActions.length >= 2);
    }, [bidsActions]);
    return (React.createElement(BidAllContext.Provider, { value: { available, subscribe, unsubscribe, bidAll } }, props.children));
};
export default BidAllContextProvider;
export function useBidAllContext() {
    return useContext(BidAllContext);
}
export function withBidAllContext(Component) {
    return (props) => {
        return (React.createElement(BidAllContextProvider, null,
            React.createElement(Component, { ...props })));
    };
}
